import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withFormik } from "formik";

import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import Input from "@material-ui/core/Input";
import InputAdornment from "@material-ui/core/InputAdornment";
import Typography from "@material-ui/core/Typography";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import Button from "@material-ui/core/Button";
import { userChangePassRequest } from "store/state/users";
import { withStyles } from "@material-ui/core/styles";

const styles = {
  root: {
    background: "transparent"
  },
  input: {
    color: "#333",
    fontWeight: "100",
    backgroundColor: "#fff",
    fontFamily: "Roboto"
  },
  divider: {
    backgroundColor: "#fff",
    marginBottom: "10px",
    marginTop: "10px"
  },
  white: {
    color: "#fff",
    fontFamily: "Futura",
    fontWeight: "bold",
    letterSpacing: "1px",
    lineHeight: "1em"
  },
  blue: {
    color: "#0f90d0",
    fontFamily: "Futura",
    fontWeight: "bold",
    letterSpacing: "1px",
    lineHeight: "1em"
  },
  caption: {
    color: "#fff",
    fontWeight: "100",
    letterSpacing: "1px",
    fontFamily: "Roboto"
  },
  boldText: {
    fontWeight: "900"
  },
  button: {
    backgroundColor: "rgba(15, 144, 208, 1)",
    color: "#fff",
    width: "100px",
    borderRadius: "20px",
    fontFamily: "Roboto",
    "&:hover": {
      backgroundColor: "rgba(15, 144, 208, .7)"
    }
  },
  label: {
    fontFamily: "Roboto",
    color: "#fff",
    fontWeight: "100",
    letterSpacing: "1px",
    
    marginBottom: "5px"
  }
};

class ResetPass extends Component {
  state = {
    passwordVisible: false
  };

  togglePasswordMask = () =>
    this.setState(prevState => ({
      passwordVisible: !prevState.passwordVisible
    }));

  toggleNewPasswordMask = () =>
    this.setState(prevState => ({
      newPasswordVisible: !prevState.newPasswordVisible
    }));

  handleGoBack = e => {
    e.preventDefault();
    this.props.history.goBack();
  };

  render() {
    const {
      classes,
      handleChange,
      handleSubmit,
      values,
      errors,
      touched
    } = this.props;

    return (
      <Fragment>
        {/* <Styles> */}
        <Grid className="login_Panel" container spacing={24}>
          <Grid item xs={12} className="login_PanelInner">
            <Paper className="login_PanelInnerPaper shouldAnimate animateDownFadeIn">
              <form onSubmit={handleSubmit} id="login_no_human">
                <Grid container spacing={24}>
                  <Grid item xs={12}>
                    <FormControl
                      fullWidth
                      error={errors.oldPassword && touched.oldPassword}
                    >
                      <Typography variant="body1" className={classes.label}>
                        Old Password
                      </Typography>
                      <Input
                        variant="filled"
                        id="oldPassword"
                        className={classes.input}
                        type={this.state.passwordVisible ? "text" : "password"}
                        value={values.oldPassword}
                        autoComplete="off"
                        onChange={handleChange}
                        placeholder=" Old Password"
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              onClick={this.togglePasswordMask}
                              onMouseDown={this.handle_MouseDownPassword}
                            >
                              {this.state.passwordVisible ? (
                                <Visibility />
                              ) : (
                                <VisibilityOff />
                              )}
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                      {errors.oldPassword &&
                        touched.oldPassword && (
                          <FormHelperText id="name-error-text">
                            {errors.oldPassword}
                          </FormHelperText>
                        )}
                    </FormControl>
                  </Grid>

                  <Grid item xs={12}>
                    <FormControl
                      fullWidth
                      error={errors.newPassword && touched.newPassword}
                    >
                      <Typography variant="body1" className={classes.label}>
                        New Password
                      </Typography>
                      <Input
                        variant="filled"
                        id="newPassword"
                        className={classes.input}
                        type={
                          this.state.newPasswordVisible ? "text" : "password"
                        }
                        value={values.newPassword}
                        autoComplete="off"
                        onChange={handleChange}
                        placeholder=" Old Password"
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              onClick={this.toggleNewPasswordMask}
                              onMouseDown={this.handle_MouseDownPassword}
                            >
                              {this.state.newPasswordVisible ? (
                                <Visibility />
                              ) : (
                                <VisibilityOff />
                              )}
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                      {errors.newPassword &&
                        touched.newPassword && (
                          <FormHelperText id="name-error-text">
                            {errors.newPassword}
                          </FormHelperText>
                        )}
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} className="changepass_buttons">
                    <Button
                      type="submit"
                      size="large"
                      className={classes.button}
                    >
                      Submit
                    </Button>
                    <Button
                      size="large"
                      className={classes.button}
                      onClick={this.handleGoBack}
                    >
                      Cancel
                    </Button>
                  </Grid>
                </Grid>
              </form>
            </Paper>
          </Grid>
        </Grid>
        {/* </Styles> */}
      </Fragment>
    );
  }
}

const mapStateToProps = ({ users, authentication }) => ({
  users,
  authentication
});

const validate = values => {
  const errors = {};
  const {
    authentication: { user }
  } = values.props;
  const userIsSystemAdmin = user.roles.includes("systemAdmin");
  if (!values.oldPassword && userIsSystemAdmin !== true) {
    errors.oldPassword = "Required";
  }
  if (!values.newPassword) {
    errors.newPassword = "Required";
  }

  return errors;
};

export default compose(
  connect(
    mapStateToProps,
    { userChangePassRequest }
  ),
  withFormik({
    mapPropsToValues: props => ({
      oldPassword: "",
      newPassword: "",
      props
    }),
    validate,
    handleSubmit: (values, { props }) => {
      const payload = {
        oldPassword: values.oldPassword,
        newPassword: values.newPassword
      };
      props.userChangePassRequest({ payload, id: props.match.params.userId });
    },
    displayName: "ResetPassForm"
  }),
  withStyles(styles)
)(ResetPass);
